import CreditBalance from "components/CreditBalance/CreditBalance";
import Table from "../../components/Table";

export default function SmsPanel() {
    return <Table type="sms" MidComponent={() => <CreditBalance credit={0}/>}/>;
}
